import { render } from "./mat-select.vue?vue&type=template&id=b8750b40&scoped=true&lang=true"
import script from "./mat-select.vue?vue&type=script&lang=js"
export * from "./mat-select.vue?vue&type=script&lang=js"

import "./mat-select.vue?vue&type=style&index=0&id=b8750b40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8750b40"]])

export default __exports__